module.exports = __webpack_public_path__ + "static/img/payCode.d25ce40b.png";